// extracted by mini-css-extract-plugin
export default {"Container":"insights-layout-module__Container--ZSZX9","Pane":"insights-layout-module__Pane--iuHaK","MainContent":"insights-layout-module__MainContent--_LDvf"};